import samune_2 from '../img/samune/2_サムネ_縦長_フォニィ.png'
import samune_4 from '../img/samune/4_サムネ_縦長_Overdose.png'
import samune_8 from '../img/samune/8_サムネ_縦長_可愛くてごめん.png'
import samune_13 from '../img/samune/13_サムネ_縦長_残機.png'
import samune_29 from '../img/samune/29_サムネ_縦長_何にでも牛乳を注ぐ女.png'
import samune_31 from '../img/samune/31_サムネ_縦長_回る空うさぎ.png'
import samune_52 from '../img/samune/52_サムネ_縦長_ガーネット.png'
import samune_57 from '../img/samune/57_サムネ_縦長_テレキャスタービーボーイ.png'
import samune_59 from '../img/samune/59_サムネ_縦長_斜陽.png'
import samune_62 from '../img/samune/62_サムネ_縦長_きゅうくらりん.png'
import samune_65 from '../img/samune/65_サムネ_縦長_Booo.png'
import samune_70 from '../img/samune/70_サムネ_縦長_三日月ステップ.png'
import samune_77 from '../img/samune/77_サムネ_縦長_私は、私達は.png'
import samune_88 from '../img/samune/88_サムネ_縦長_サインはB.png'
import samune_93 from '../img/samune/93_サムネ_縦長_ラビットホール.png'
import samune_96 from '../img/samune/96_サムネ_縦長_月のワルツ.png'
import samune_119 from '../img/samune/119_サムネ_縦長_勇者.png'
import samune_124 from '../img/samune/124_サムネ_縦長_猛独が襲う.png'
import samune_125 from '../img/samune/125_サムネ_縦長_撫でんな.png'
import samune_127 from '../img/samune/127_サムネ_縦長_HappyHalloween.png'
import samune_129 from '../img/samune/129_サムネ_縦長_カワキヲアメク.png'
import samune_130 from '../img/samune/130_サムネ_縦長_クラクラ.png'
import samune_135 from '../img/samune/135_サムネ_縦長_キュートなカノジョ.png'

function samune() {
  const samuneImage = [
    samune_2,
    samune_4,
    samune_8,
    samune_13,
    samune_29,
    samune_31,
    samune_52,
    samune_57,
    samune_59,
    samune_62,
    samune_65,
    samune_70,
    samune_77,
    samune_88,
    samune_93,
    samune_96,
    samune_119,
    samune_124,
    samune_125,
    samune_127,
    samune_129,
    samune_130,
    samune_135,
  ]
  return samuneImage
}
export default samune
